var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTryDapps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.625C0 3.31129 2.68629 0.625 6 0.625H34C37.3137 0.625 40 3.31129 40 6.625V34.625C40 37.9387 37.3137 40.625 34 40.625H6C2.68629 40.625 0 37.9387 0 34.625V6.625Z",
    fill: "#C4F538",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2627 23.1385C24.0371 23.3935 23.8004 23.6454 23.5529 23.8929C19.973 27.4727 15.4881 28.7918 13.5355 26.8392C12.1968 25.5005 12.3959 22.9717 13.807 20.3602M15.7413 17.6111C15.9761 17.3441 16.223 17.0806 16.4818 16.8219C20.0616 13.2421 24.5465 11.923 26.4991 13.8756C27.8387 15.2152 27.6384 17.7466 26.2247 20.36M23.5529 16.8219C27.1327 20.4017 28.4518 24.8866 26.4991 26.8392C24.5465 28.7918 20.0616 27.4727 16.4818 23.8929C12.902 20.3131 11.5829 15.8282 13.5355 13.8756C15.4881 11.923 19.973 13.2421 23.5529 16.8219ZM20.8333 20.34C20.8333 20.8002 20.4602 21.1733 20 21.1733C19.5397 21.1733 19.1666 20.8002 19.1666 20.34C19.1666 19.8798 19.5397 19.5067 20 19.5067C20.4602 19.5067 20.8333 19.8798 20.8333 20.34Z",
    stroke: "#C4F538",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryDapps);
export default __webpack_public_path__ + "static/media/try-dapps.ec5e8fe19fffe89fb4a5253c64ddd264.svg";
export { ForwardRef as ReactComponent };